var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inheritance-toggle"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOverridden),
      expression: "isOverridden"
    }],
    staticClass: "uk-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOverridden) ? _vm._i(_vm.isOverridden, null) > -1 : (_vm.isOverridden)
    },
    on: {
      "input": _vm.onInput,
      "__c": function($event) {
        var $$a = _vm.isOverridden,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOverridden = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isOverridden = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOverridden = $$c
        }
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.toggleLabel) + "\n    ")])]), _vm._v(" "), (_vm.isOverridden) ? _c('div', {
    staticClass: "inheritance-toggle__container inheritance-toggle__container--overridden"
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "inheritance-toggle__container inheritance-toggle__container--inherited"
  }, [_vm._t("inherited")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ca84253","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/InheritanceToggle.vue
// module id = 1885
// module chunks = 0